import { useCallback } from 'react';
import { useAuthStore } from '../stores/authStore';
import type { LoginRequest, RegisterRequest } from '../types/auth';

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    fetchUserInfo,
  } = useAuthStore();

  // 执行登录
  const handleLogin = useCallback(async (data: LoginRequest) => {
    await login(data);
  }, [login]);

  // 执行登出
  const handleLogout = useCallback(async () => {
    await logout();
  }, [logout]);

  // 获取当前用户角色
  const userRole = user?.role;

  // 检查是否为管理员（owner或admin）
  const isAdmin = userRole === 'owner' || userRole === 'admin';

  // 检查是否为所有者
  const isOwner = userRole === 'owner';

  return {
    user,
    isAuthenticated,
    isLoading,
    userRole,
    isAdmin,
    isOwner,
    login: handleLogin,
    logout: handleLogout,
    fetchUserInfo,
  };
};
